export enum IconsModel {
  next = 'next',
  previous = 'previous',
  up = 'expand',
  down = 'collapse',
  world = 'world',
  drop = 'drop',
  play = 'play',
  close = 'close',
  muted = 'muted',
  unmuted = 'unmuted',
  left = 'left',
  right = 'right',
  home = 'home',
  dropdown = 'dropdown',
}
export const iconsValues = Object.values(IconsModel)
export type iconsArray = typeof iconsValues
export type TypeIcons = iconsArray[number]

export enum IconsStyle {
  fill = 'fill',
  outline = 'outline',
}
export const iconsStyleValues = Object.values(IconsStyle)
export type iconsStyleArray = typeof iconsStyleValues
export type TypeStyleIcons = iconsStyleArray[number]
